import Vue from 'vue'
//import './plugins/axios'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify';
//import '@babel/polyfill'

Vue.config.productionTip = false

import MixinRoot from '../../cliente-comun/mixins/root'

new Vue({
  router,
  vuetify,
	render: h => h(App),
	mixins: [MixinRoot],
}).$mount('#app')
